import { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request } from '../core/request';
import { ClientFileType } from '/src/lib/models/ClientFileType';

export class ClientFileTypeService {
  /**
   * List ClientFileTypes
   * @returns ClientFileType[]
   */
  public static listClientFileTypes(): CancelablePromise<ClientFileType[]> {
    return request(OpenAPI, {
      method: 'GET',
      url: '/clientFileTypes',
    });
  }
}
